import React from 'react';
import {h, Component} from 'preact'

export default class UnreadMessagesBadge extends Component {
    render() {
        const { newMessagesCount, onClick } = this.props;

        return (
            <div className={'unread-messages'} onClick={onClick}>
                Unread messages ({newMessagesCount})
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/UnreadMessagesBadge.js